import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserDetail } from "@store/generalTypes";
import { isEmpty } from "lodash";

const emptyUserDetail: UserDetail = {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    jobTitle: "",
    title: "",
    isAdmin: false,
    hasAccess: false,
    organizations: [],
    locations: []
};

export const initialState = emptyUserDetail;

const userDetailSlice = createSlice({
    name: "userDetail",
    initialState,
    reducers: {
        setMyPermission(state, action: PayloadAction<UserDetail>) {
            state.email = action.payload.email;
            state.firstName = action.payload.firstName;
            state.id = action.payload.id;
            state.isAdmin = action.payload.isAdmin;
            state.jobTitle = action.payload.jobTitle;
            state.lastName = action.payload.lastName;
            state.organizations = action.payload.organizations;
            state.locations = action.payload.locations;
            state.title = action.payload.title;
            state.hasAccess = !isEmpty(action.payload.organizations);
        }
    }
});

export const { setMyPermission } = userDetailSlice.actions;

export default userDetailSlice.reducer;
